import $ from 'jquery';
class Like {
    constructor(){
        //alert('test like js');
        this.events();
    }

    events(){
        $(".like-box").on("click", this.ourClickDispatcher.bind(this));
    }


    // methods
    ourClickDispatcher(e){
        var currentLikeBox = $(e.target).closest('.like-box');
        if(currentLikeBox.attr('data-exists') == 'yes'){
            this.deleteLike(currentLikeBox);
        }else {
            this.createLike(currentLikeBox);
        }
    }

    createLike(currentLikeBox){
        $.ajax({
            beforeSend:(xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',universityData.nonce)
            },
            url:universityData.root_url+'/wp-json/university/v1/manageLike',
            type:'POST',
            data:{'professorId':currentLikeBox.data('proffessor')},
            success:(response)=>{
                currentLikeBox.attr('data-exists','yes');
                var likedCount = parseInt(currentLikeBox.find(".like-count").html());
                likedCount++;
                console.log(likedCount);
                currentLikeBox.find(".like-count").html(likedCount);
                currentLikeBox.attr('data-like',response);
                console.log('CREATE ');
                console.log(response);
            },
            error:(response)=>{
                console.log('ERROR ');
                console.log(response);
            },
        })
    }

    deleteLike(currentLikeBox){
        $.ajax({
            beforeSend:(xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',universityData.nonce)
            },
            url:universityData.root_url+'/wp-json/university/v1/manageLike',
            data:{'like':currentLikeBox.data('like')},
            type:'DELETE',
            success:(response)=>{
                currentLikeBox.attr('data-exists','no');
                var likedCount = parseInt(currentLikeBox.find(".like-count").html());
                likedCount--;
                console.log(likedCount);
                currentLikeBox.find(".like-count").html(likedCount);
                currentLikeBox.attr('data-like','');

                console.log('SUCCESS DEL ');
                console.log(response);
            },
            error:(response)=>{
                console.log('ERROR DEL ');
                console.log(response);
            },
        })
    }
}

export default Like;